import { useSetRecoilState } from "recoil";
import { googleReviewsDateRangeState } from "../../../store/googleReviewsDateRangeState";
import { googleReviewRatingState } from "../../../store/googleReviewRatingState";
import { useNavigate } from "react-router-dom";

export const useResetReviewReplyFilter = () => {
  const navigate = useNavigate()
  const setDateRange = useSetRecoilState(googleReviewsDateRangeState);
  const setReviewRating = useSetRecoilState(googleReviewRatingState);
  const resetFilter = () => {
    navigate('/line/login/google/reviews/replies/')
    setDateRange({ since: null, until: null })
    setReviewRating(null)
  }
  return resetFilter
};